// extracted by mini-css-extract-plugin
export var content = "_83-1";
export var modal = "_83-0";